import CustomCarousel from "../../components/carousel/HairstyleCarousel"

export default function PriceList() {

    return <>
        {/*<div className="relative pb-4 cursor-default">
            <div className="flex justify-center">
                <img src={haircutImage} alt="Haarschnitt Männer" className="w-[95%] rounded-sm" />
            </div>

            <div className="absolute bottom-[40%] left-[50%] translate-x-[-50%] z-10">
                <p className="text-3xl font-semibold text-white">PREISLISTE</p>
            </div>
        </div> */}

        <div className="relative pb-1 sm:pt-[5%] pt-[15%]">
            <div className="absolute bottom-[50%] left-[50%] translate-x-[-50%] translate-y-[50%] z-10">
                <p className="text-2xl sm:text-6xl font-semibold text-white tracking-wide">PREISLISTE</p>
            </div>
        </div>

        <div className="flex flex-wrap justify-between">
            <div className="sm:pl-[20%] pl-10">
                <div className="pb-3">
                    <p className="font-semibold text-lg">
                        Schneiden
                    </p>
                    <p>
                        € 81,- bis € 89,-
                    </p>
                </div>
                <div className="pb-3">
                    <p className="font-semibold text-lg">
                        Haare schön machen (waschen / föhnen / stylen)
                    </p>
                    <p>
                        € 45,- bis € 59,-
                    </p>
                </div>
                <div className="pb-3">
                    <p className="font-semibold text-lg">
                        Haare schön machen (Ohne waschen / Locken / Glätten)
                    </p>
                    <p>
                        € 49,-
                    </p>
                </div>
                <div className="pb-3">
                    <p className="font-semibold text-lg">
                        Farbveränderung
                    </p>
                    <p>
                        € 69,- bis € 120,-
                    </p>
                </div>
                <div className="pb-3">
                    <p className="font-semibold text-lg">
                        Airtouch Technik (Blond Sepcial)
                    </p>
                    <p>
                        Preis auf Anfrage
                    </p>
                </div>
            </div>

            <div className="pr-[20%] sm:pl-[20%] pl-10">
                <div className="pb-3">
                    <p className="font-semibold text-lg">
                        Farbauffrischung Smoothie
                    </p>
                    <p>
                        Pro Gramm € 1,50
                    </p>
                </div>
                <div className="pb-3">
                    <p className="font-semibold text-lg">
                        Farbauffrischung Gloss
                    </p>
                    <p>
                        Pro Gramm € 1,50
                    </p>
                </div>
                <div className="pb-3">
                    <p className="font-semibold text-lg">
                        Augenbrauen oder Wimpern färben
                    </p>
                    <p>
                        je € 15,-
                    </p>
                </div>
                <div className="pb-3">
                    <p className="font-semibold text-lg">
                        Pflegebehandlungen
                    </p>
                    <p>
                        € 7,- bis € 25,-
                    </p>
                </div>
                <div className="pb-3">
                    <p className="font-semibold text-lg">
                        Olaplex-Zusatz
                    </p>
                    <p>
                        Preis auf Anfrage
                    </p>
                </div>
            </div>
        </div>

        <div className="flex h-96 justify-center pl-[30%] pr-[30%] pt-10 ">
            <CustomCarousel />
        </div>
    </>
}